import {call, cancel, delay, fork, takeEvery} from 'redux-saga/effects';
import {MARK_COMMENT_AS_READ} from './constants';
import app from '../../../helpers/app';
import {Task} from 'redux-saga';

const ids: { [index: number | string]: true } = {};
let task: Task | null = null;
let requestPromise: Promise<any> = Promise.resolve();

export function* markableAsReadFeatureSaga() {
    yield takeEvery(MARK_COMMENT_AS_READ, function* (action) {
        if (
            !('payload' in action) ||
            typeof action.payload !== 'number' &&
            typeof action.payload !== 'string'
        ) {
            return;
        }

        ids[action.payload] = true;
        if (requestPromise) {
            yield requestPromise;
        }

        if (task) {
            yield cancel(task);
        }

        task = yield fork(function* (commentsIds: Array<keyof typeof ids>) {
            yield delay(1000);

            yield call(() => {
                return requestPromise = app('http').route('comments.mark-as-read', {}, {
                    headers: {'content-type': 'application/json'},
                    body: {
                        'controller-name': 'Comments',
                        ids: commentsIds,
                    }
                }).then(v => {
                    commentsIds.forEach(id => {
                        delete ids[id];
                    });

                    task = null;

                    return v;
                });
            });
        }, Object.keys(ids));
    });
}
